import { TokenRow } from '../types';
import { FC } from 'react';
import DateCell from './DateCell';
import { DefaultCell } from '@silverfort/sf-components';

type Props = TokenRow;

const LastUsedCell: FC<Props> = ({ lastUsed }) => {
    if (!lastUsed) {
        return <DefaultCell text="N/A" />;
    }

    return <DateCell date={lastUsed} />;
};

export default LastUsedCell;
